jQuery(document).ready(function($) {
    const transformY = (el, elHeight, scrollY, windowHeight) => {
        const elTop = el.offset().top;
        
        const elMid = elTop + (elHeight / 2);
        const scrollMid = scrollY + (windowHeight / 2);
        const scrollPercent = (scrollMid - elMid) / (windowHeight / 2);
        
        return scrollPercent * 10;
    }
    
    const scrollScale = (el, elHeight, scrollY, windowHeight) => {
        let element = el.closest('.inset-parallax');
        const elTop = element.offset().top;
        const elBottom = element.offset().top + element.outerHeight();
        
        const scrollPercent = (scrollY - elTop) / (elBottom - elTop);
        const scale = (scrollPercent * 0.05) + 1.1;
        
        if ( scale < 1 ) {
            return 1;
        }
        
        return scale;
    }
    
    const el = $('.inset-parallax');
    el.each(function(){
        const img = $(this).find('img');
        
        $(window).on('scroll', function(){
            const scrollY = $(this).scrollTop();
            const windowHeight = $(this).height();
            const elHeight = img.outerHeight();
            
            const transform = transformY( img, elHeight, scrollY, windowHeight );
            const scale = scrollScale( img, elHeight, scrollY, windowHeight );
            
            img.css({
                'transform': `translate3d(0px, ${transform}%, 0px) scale3d(${scale}, ${scale}, ${scale}) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)`
            });
        });
    });
    
});